import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const CODE_GENERATOR_API_URL = `${API_HOST}/api/codeGenerator`;

function* createCodeGenerator() {
  yield takeEvery(actions.CREATE_CODE_GENERATOR, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], CODE_GENERATOR_API_URL, data);
      yield put({ type: actions.CREATE_CODE_GENERATOR_ENDED });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_CODE_GENERATOR_ENDED });
    }
  });
}

function* searchCodeGenerators() {
  yield takeEvery(actions.SEARCH_CODE_GENERATORS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${CODE_GENERATOR_API_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_CODE_GENERATORS_ENDED });
    }
  });
}

function* findCodeGenerator() {
  yield takeEvery(actions.FIND_CODE_GENERATOR, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${CODE_GENERATOR_API_URL}/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.FIND_CODE_GENERATOR_ENDED });
    }
  });
}

function* updateCodeGenerator() {
  yield takeEvery(actions.UPDATE_CODE_GENERATOR, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], CODE_GENERATOR_API_URL, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_CODE_GENERATOR_ENDED });
    }
  });
}

function* deleteCodeGenerators() {
  yield takeEvery(actions.DELETE_CODE_GENERATORS, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], CODE_GENERATOR_API_URL, { data });
      yield put({ type: actions.DELETE_CODE_GENERATORS_ENDED });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_CODE_GENERATORS_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createCodeGenerator),
    fork(searchCodeGenerators),
    fork(findCodeGenerator),
    fork(updateCodeGenerator),
    fork(deleteCodeGenerators),
  ]);
}
